/* HUGGO MOTION v1 — entrance reveals + scroll-driven light. No deps. */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.__hgmInit) return;
  window.__hgmInit = true;

  var lights = [];
  var revealCount = 0;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('hgm-in');
          io.unobserve(e.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  function reveal(el) {
    if (!el || el.classList.contains('hgm-reveal')) return;
    el.classList.add('hgm-reveal');
    el.style.setProperty('--hgm-d', (revealCount % 5) * 80 + 'ms');
    revealCount++;
    io.observe(el);
  }

  function addLight(el, isCard) {
    if (!el || el.classList.contains('hgm-light')) return;
    if (el.closest('header, footer, dialog, [class*="drawer"], [class*="modal"]')) return;
    el.classList.add('hgm-light');
    if (isCard) el.classList.add('hgm-card');
    lights.push(el);
  }

  function scan() {
    var main = document.querySelector('main') || document.body;

    /* product cards (Horizon uses <product-card>) */
    var cards = main.querySelectorAll('product-card, .product-card, [class*="product-grid"] > *');
    cards.forEach(function (c) {
      reveal(c);
      var media = c.querySelector('img');
      if (media) {
        var box = media.closest('.product-media-container, [class*="media"], a') || media.parentElement;
        addLight(box, true);
      }
    });

    /* headings, copy blocks, buttons */
    main.querySelectorAll('h1, h2, .rte, .button, a.button').forEach(function (el) {
      if (!el.closest('.hgm-reveal')) reveal(el);
    });

    /* large standalone images (hero, banners, PDP gallery) */
    main.querySelectorAll('img').forEach(function (img) {
      var w = img.clientWidth, h = img.clientHeight;
      if (w >= 300 && h >= 260) {
        var p = img.parentElement;
        addLight(p, false);
      }
    });

    /* parallax on the first big visual of the page */
    var first = main.querySelector('.hgm-light:not(.hgm-card)');
    if (first) first.classList.add('hgm-par');

    update();
  }

  var ticking = false;
  function update() {
    ticking = false;
    var vh = window.innerHeight;
    for (var i = 0; i < lights.length; i++) {
      var el = lights[i];
      var r = el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) continue;
      var p = 1 - (r.top + r.height / 2) / vh;
      p = Math.max(0, Math.min(1, p));
      el.style.setProperty('--hgm-p', p.toFixed(3));
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  /* re-scan after full load: lazy images now have dimensions */
  window.addEventListener('load', function () { setTimeout(scan, 300); });
})();
